import React, {Component} from 'react'
/** LOADING COMPONENT **/
// import {PulseLoader} from 'halogen'

import _ from 'lodash';
import async from 'async';
import { CSVLink, CSVDownload } from "react-csv";

import Dygraph from '../../../../synchronizer'

/**HIGHCHARTS COMPONENT **/


import './StationCharts.css'
/** OWN COMP **/
import {DateSelector} from './DateSelector/DateSelector'
import SnackBarContainer from './SnackBarContainer/SnackBarContainer'
// REDUX IMPORTS
import {connect} from 'react-redux'
import {bindActionCreators} from 'redux'
import * as nodeChartsActions from '../../../../actions/nodeCharts'
import * as WebSocketActions from '../../../../actions/webSocket'
import * as StationActions from '../../../../actions/stations';

import LineChart from '../../../Chart/LineChart';


import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'

const MySwal = withReactContent(Swal);
const ErrorSwal = (text) => {
    MySwal.fire({
        type: 'error',
        title: 'Incorrect date',
        text: text
    });
};

const csvData = [
    ["firstname", "lastname", "email"],
    ["Ahmed", "Tomi", "ah@smthing.co.com"],
    ["Raed", "Labes", "rl@smthing.co.com"],
    ["Yezzi", "Min l3b", "ymin@cocococo.com"]
];

class StationCharts extends Component {

    constructor() {
        super();

        this.state = {
            stations: null,
            download: false,
            alias: null,
            from: new Date(new Date() - 1000 * 60 * 60 * 24),
            to: new Date(),
            online: false,
            group: 1,
            graphs: {
                CO: {
                    active: false,
                    handle: null
                },
                H2: {
                    active: false,
                    handle: null
                },
                NO: {
                    active: false,
                    handle: null
                },
                NO2: {
                    active: false,
                    handle: null
                },
                O3: {
                    active: false,
                    handle: null
                },
                PM_1: {
                    active: false,
                    handle: null
                },
                PM_10: {
                    active: false,
                    handle: null
                },
                PM_2P5: {
                    active: false,
                    handle: null
                },
                PRESSURE: {
                    active: false,
                    handle: null
                },
                R_HUMIDITY: {
                    active: false,
                    handle: null
                },
                SO2: {
                    active: false,
                    handle: null
                },
                TEMPERATURE: {
                    active: false,
                    handle: null
                }
            },
            sync: [],
            loading: true,
            batch: null,
            labels: null,


            error: false,
            errorMsg: '',
            errorTittle: '',
        };

        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleSync = this.handleSync.bind(this);
        this.handleCSV = this.handleCSV.bind(this);
    }

    componentDidMount() {
        //     /stations/chart/ateknea_01,ateknea_02,ateknea_03,/from/2018-08-27T15:32:22Z/to/2018-08-28T15:32:22
        let stations;
        let from = this.props.match.params.from ? new Date(this.props.match.params.from) : this.state.from;
        from = new Date(from - 1000*((from.getHours()*60 + from.getMinutes())*60 + from.getSeconds()));
        let to = this.props.match.params.to ? new Date(this.props.match.params.to) : this.state.to;
        let alias = this.props.match.params.alias ? this.props.match.params.alias.split(',') : null;

        stations = this.props.match.params.stations.split(',');
        if (!stations[stations.length - 1]) {
            stations = stations.slice(0, -1);
        }

        if(alias)
            alias = stations.map((station, key) => {return {id: station, alias: alias[key]}});

        let newState = this.state;
        newState.stations = stations;
        newState.alias = alias;

        this.setState(newState);

        this.handleSubmit(from, to, stations, alias);
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.state.batch !== prevState.batch) {
            console.log('batch change');
            let oldState = this.state.graphs;
            _.forEach(this.state.batch, (serie, key) => {
                if (key !== 'LABELS' && serie.length > 0) {
                    oldState[key].active = true;
                }
            });
            this.setState({...this.state, graphs: oldState});
        }

        if (this.state.sync.length > 0) {
            let n = _.filter(this.state.graphs, (serie => serie.active));
            if (n.length === this.state.sync.length) {
                Dygraph.synchronize(this.state.sync, {range: false});
            }
        }

        if (this.state.online !== prevState.online) {
            if (this.state.online) {
                let msg = {
                    type: 'subscription',
                    content: {
                        type: 'data',
                        service: 'stations',
                        stations: this.state.stations
                    }
                };
                this.props.webSocketActions.sendDataWebSocket(msg);
                this.handleSubmit(this.state.from, new Date(), this.state.stations, this.state.alias);
            } else {
                let msg = {
                    type: 'subscription_end',
                    content: {
                        type: 'data',
                        service: 'stations',
                        stations: this.state.stations
                    }
                };
                this.props.webSocketActions.sendDataWebSocket(msg);
            }
        }


        if (this.props.batch.length > 0){
            let data = this.props.batch[0];
            let newBatch = this.state.batch;
            let update = false;

            async.each(data, (item, cb) => {
                let index = this.state.labels.indexOf(item.id);
                let aux = [];
                let date = new Date(item.Unix_epoch.value * 1000);

                for (let i = 0; i < this.state.labels.length; i++) {
                    if (i === 0)
                        aux.push(date);
                    else if(i === index)
                        aux.push(0);
                    else
                        aux.push(null);
                }

                async.each(Object.keys(item), (key, cb2) => {
                    if(!['id', 'type', 'Unix_epoch', 'LAT', 'LON'].includes(key)){
                        let ind = newBatch[key].findIndex(element => element[0].getTime() === date.getTime());

                        if (ind >= 0 && newBatch[key][ind][index] === null){
                            console.log('change');
                            newBatch[key][ind][index] = item[key].value;
                            update = true;
                            cb2();
                        } else if (ind >= 0)
                            cb2();
                        else {
                            ind = newBatch[key].findIndex(element => element[0].getTime() > date.getTime());
                            if (ind >= 0)
                                cb2();
                            else {
                                console.log('push');
                                aux[index] = item[key].value;
                                newBatch[key].push(aux);
                                update = true;
                                cb2();
                            }
                        }
                    } else
                        cb2();
                }, err => {
                    if (err) console.log(err);
                    cb();
                })
            }, err => {
                if (err) console.log(err);
                this.props.stationActions.cleanBatch();
                if(update) {
                    Object.keys(this.state.graphs).forEach(item => {
                        if (this.state.graphs[item].active){
                            this.state.graphs[item].handle.updateOptions( { 'file': newBatch[item] } );
                        }
                    });
                    this.setState({...this.state, batch: newBatch});
                }
            });
        }
    }

    componentWillUnmount() {
        if (this.state.online){
            let msg = {
                type: 'subscription_end',
                content: {
                    type: 'data',
                    service: 'stations',
                    stations: this.state.stations
                }
            };
            this.props.webSocketActions.sendDataWebSocket(msg);
        }
    }

    handleSubmit(from, to, stations, alias) {

        let now = new Date();

        if (to > now || from > now) {
            ErrorSwal(`${to > now ? 'To date ' + to.toLocaleDateString() : 'From date ' + from.toLocaleDateString()} is in the future`);
        } else if (from > to) {
            ErrorSwal('Introduced interval is incorrect. From date is higher than to');
        } else if ((to - from) > 1000 * 60 * 60 * 24 * 31) {
            ErrorSwal('Introduced interval too large.');
        } else {
            from = new Date(from - 1000*(((from.getHours() - 1)*60 + from.getMinutes())*60 + from.getSeconds()));

            this.setState({...this.state, stations, from, to, sync: []});

            window.history.pushState(null, 'Bettair', `/stations/chart/${stations.toString()}${alias ? `/alias/${alias.map(entity => entity.alias).join()}` : ''}/from/${from.toISOString()}/to/${to.toISOString()}`);

            this.props.nodeChartsActions.fetchDataFromNode(stations, sessionStorage.getItem('x-auth-token'),
                from.toISOString(), to.toISOString(), (response, err) => {
                    if (err) {
                        console.log(response);
                    } else {
                        let label = response['LABELS'];
                        delete response['LABELS'];
                        if (alias) {
                            label = [label[0]].concat(label.slice(1).map(entity => alias.find(item => item.id === entity).alias))
                        }
                        this.setState({...this.state, loading: false, batch: response, labels: label});
                    }
                });
        }
    }

    handleChange(field, value) {
        this.setState({...this.state, [field]: value});
    }

    handleSync(name, graph) {
        let sync = this.state.sync;
        let graphs = this.state.graphs;

        sync.push(graph);
        graphs[name].handle = graph;

        this.setState({...this.state, sync: sync, graphs: graphs});
    }


    handleDisplay() {
        return Object.keys(this.state.graphs).map(serie => {
            if (this.state.graphs[serie].active)
                return <LineChart batch={this.state.batch[serie]} labels={this.state.labels} name={serie} key={serie}
                                  handleSync={this.handleSync} group={this.state.group}/>;
            else
                return null;
        });
        // if (this.state.batch) {
        //     return Object.keys(this.state.batch).map(series => {
        //
        //     });
        // } else {
        //
        //     return Object.keys(this.props.batch).map(series => {
        //         if (series !== 'time')
        //             return null
        //                 // <PulseLoader className="loadChart"
        //                 //                 color="#3B68F8"
        //                 //                 size={"20px"}
        //                 //                 margin={"4px"}
        //                 //                 key={series.toString()}/>
        //         else
        //             return ''
        //     })
        // }
    }

    handleCSV() {

        let csvData = null;
        let number = this.state.stations ? this.state.stations.length : 0;
        let name = [];
        if (number) {
            if (this.state.alias)
                this.state.alias.forEach(item => {
                    name.push(`${item.alias}_${this.state.from.toISOString()}_${this.state.to.toISOString()}_ugm3.csv`);
                });
            else
                this.state.stations.forEach(item => {
                    name.push(`${item}_${this.state.from.toISOString()}_${this.state.to.toISOString()}_ugm3.csv`);
                });
            if (this.state.batch) {
                let label = ['CO', 'H2', 'NO', 'NO2', 'O3', 'PM_1', 'PM_10', 'PM_2P5', 'PRESSURE', 'R_HUMIDITY', 'SO2', 'TEMPERATURE'];

                let start = null;
                label.forEach(item => {
                    if (this.state.batch[item].length > 0)
                        start = item;
                });

                if (start) {
                    csvData = [];
                    for (let i = 0; i < number; i++)
                        csvData.push([]);
                    for (let i = 0; i < this.state.batch[start].length; i++) {
                        let aux = {};
                        aux['INDEX'] = i + 1;
                        aux['EPOCH'] = Math.trunc(this.state.batch[start][i][0].getTime() / 1000);
                        aux['TIMESTAMP'] = this.state.batch[start][i][0].toISOString();

                        for (let e = 0; e < number; e++) {
                            label.forEach(item => {
                                if (this.state.batch[item].length > 0) {
                                    aux[item] = this.state.batch[item][i][e + 1];
                                }
                            });

                            csvData[e].push(Object.assign({},aux));
                        }
                    }
                }

            }
        }

        if (csvData) {
            if (this.state.alias)
                return (
                    <div>
                        {this.state.alias.map((station, i) => {
                            return (<p key={i}><CSVLink
                                data={csvData[i]}
                                filename={name[i]}
                            >
                                Download {station.alias} data
                            </CSVLink></p>);
                        })
                        }
                    </div>
                );
            else
                return(
                    <div>
                        {this.state.stations.map((station, i) => {
                            return(<p key={i}>
                                <CSVLink
                                    key={i}
                                    data={csvData[i]}
                                    filename={name[i]}
                                >
                                    Download {station} data
                                </CSVLink></p>);
                        })}
                    </div>);
        } else
            return null;

    }

    render() {

        return (
            <div className=" col-xs-12 ">
                <DateSelector
                    from={this.state.from}
                    to={this.state.to}
                    stations={this.state.stations}
                    handleSubmit={this.handleSubmit}
                    handleChange={this.handleChange}
                    online={this.state.online}
                    group={this.state.group}
                    alias={this.state.alias}
                />

                {this.handleCSV()}

                <div className='row'>
                    <div className='col-xs-12'>
                        {this.handleDisplay()}
                    </div>
                </div>
                <SnackBarContainer/>
            </div>
        )
    }
}


const dashboardStateToProps = (state) => {
    return {
        batch: state.stations.batch,
    }
};

const dashboardDispatchToProps = (dispatch) => {
    return {
        nodeChartsActions: bindActionCreators(nodeChartsActions, dispatch),
        webSocketActions: bindActionCreators(WebSocketActions, dispatch),
        stationActions: bindActionCreators(StationActions, dispatch)
    }
};

export default connect(dashboardStateToProps, dashboardDispatchToProps)(StationCharts)



// WEBPACK FOOTER //
// ./src/components/DashBoard/ManageStations/StationCharts/StationCharts.js